const URL_APP = process.env.VUE_APP_URL_API;

export default URL_APP
